// # #############################################
// # Title : Scenario Wizard
// # Authors : Sameer, Atul
// # Date : 15th October 2019
// # Last Modified : Shubham, October 2019
// # Version : 19.10.03
// # Description : This is the code for the create scenario wizard
// # ############################################

import React from "react";
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";
import GlobalEvents from "../utils/global-events";
import SimSettings from './simSettings';
import ProductWidget from './ProductWidget';
import { abbreviateNumber } from "../utils/helperFunction";
import config from "../utils/config";
import '../css/ScenarioWizard.css';

var moment = require('moment');

const styles = theme => ({
  button: {
    width: "7vw",
    minWidth: "80px",
    backgroundColor: "#00a7bd"
  },
  label: {
    fontSize: '1.5vw',
    wordBreak: 'break-all'
  },
  stepActive: {
    color: "#7fd3de !important"
  },
  stepCompleted: {
    color: "#177482!important"
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  }
});

class ScenarioWizard extends React.Component {

  state = {
    activeStep: 0,
    showDialog: true,
    scenarioName: null,
    scenarioDescription: null,
    openSnackBar: false
  };

  showDialog() {
    this.setState({
      showDialog: false
    })
    GlobalEvents.trigger('handleScenario', 0)
  }

  handleChange(e, event) {
    this.setState({
      [e]: event.target.value
    })
  };

  updateText() {

    const scenarioName = document.getElementById("ScenarioName").innerHTML;
    const scenarioDescription = document.getElementById("ScenarioDescription").innerHTML

    if (scenarioName.length > 0 && this.state.activeStep === 3) {
      this.setState({
        scenarioName: scenarioName,
        scenarioDescription: scenarioDescription
      })
    }
  }

  getSnackBar() {

    const { classes } = this.props;

    return (
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={this.state.openSnackBar}
        autoHideDuration={3000}
        onClose={() => { this.setState({ openSnackBar: false }) }}
      >
        <SnackbarContent
          className={classes.error}
          onClose={() => { this.setState({ openSnackBar: false }) }}
          message="Scenario name and description must not be empty!"
          action={[
            <IconButton
              key="close"
              aria-label="close"
              color="inherit"
              onClick={() => { this.setState({ openSnackBar: false }) }}
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </Snackbar>
    )
  }

  getStepContent = (step) => {

    let product = "";
    let iconSrc = "";

    if (step === 3) {
      product = JSON.parse(JSON.parse(JSON.stringify(sessionStorage.getItem('productData')))).product_data.category;
      if (product === "tea") {
        iconSrc = "tea.svg";
        product = "Tea";
      } else if (product === "coffee") {
        iconSrc = 'coffee-mug.svg';
        product = "Coffee";
      } else if (product === "fruit") {
        iconSrc = 'juice.svg';
        product = "Juice";
      } else if (product === "milk") {
        iconSrc = 'milk.svg';
        product = "Milk";
      } else if (product === "carbonation") {
        iconSrc = 'soft-drink.svg';
        product = "SE Drink";
      } else if (product === "water") {
        iconSrc = 'water.svg';
        product = "Water";
      }
    }

    switch (step) {
      case 0:
        return (
          <div className="objectiveView">
            <div className="goal">
              Goal
            </div>
            <div className="description">
              The objective of the game is to design a product and simulate its launch with the objective to maximize market share. You can monitor your simulation and change levers such as price and promotion to achieve your objective.
            </div>
            <div className="gamePlay">
              Game Play
            </div>
            <div className="iconRowStyle">
              <div className="iconStyle">
                <img className="agent" src='agents.svg' alt='Agents' />
                <div className="agentsText">Set number of agents</div>
              </div>
              <div className="iconStyle">
                <img className="clock" src='sand-clock.svg' alt='Timer' />
                <div className="clockText">
                  Set time period
                </div>
              </div>
              <div className="iconStyle">
                <img className="control" src='control.svg' alt='Settings' />
                <div className="controlText">Tweak agent behaviour</div>
              </div>
            </div>
            <div className="iconRowStyle">
              <div className="iconStyle">
                <img className="beverage" src='coffee-mug.svg' alt='Product' />
                <div className="beverageText">Create your preferred beverage</div>
              </div>
              <div className="iconStyle">
                <img className="price" src='pricing-tag.svg' alt='Pricing' />
                <div className="priceText">Fix the price and profit percentage   </div>
              </div>
              <div className="iconStyle">
                <img className="promotion" src='promotion-horn.svg' alt='Promotions' />
                <div className="promotionText" > Setup a promotion campaign  </div>
              </div>
            </div>
            <div></div>
            <div className="happyBrewing">  Happy brewing to you! </div>
          </div>
        );
      case 1:
        return (
          <React.Fragment>
            <SimSettings showNotification={this.props.showNotification} />
          </React.Fragment>
        );
      case 2:
        return (
          <React.Fragment>
            <ProductWidget showNotification={this.props.showNotification}> </ProductWidget>
          </React.Fragment>
        );
      case 3:
        return (
          <div className="saveScenario">
            {this.getSnackBar()}
            <div className="saveScenarioLeft">
              <text className="saveScenarioTitle">Name and description</text>
              <div className="saveScenarioTitle subTitles" >Scenario Name </div>
              <div id="ScenarioName" className="scenarioTextField ScenarioName" contenteditable="true" data-text="Add Scenario Name">{this.state.scenarioName ? this.state.scenarioName : null}</div>
              <div className="saveScenarioTitle subTitles">Scenario Description </div>
              <div id="ScenarioDescription" className="scenarioTextField ScenarioDescription" contenteditable="true" data-text="Add Scenario Description">{this.state.scenarioDescription ? this.state.scenarioDescription : null}</div>
            </div>
            <div className="saveScenarioRight">
              <text className="saveScenarioTitle">Summary</text>
              <div className="saveScenarioRightInner">
                <div className="saveScenarioAgents">
                  <img className="agentIcon" src='agents.svg' alt='Agents' />
                  <i>{abbreviateNumber(sessionStorage.getItem("no_of_agents") ? sessionStorage.getItem("no_of_agents") : 5000)} agents</i>
                </div>
                <div className="saveScenarioDuration">
                  <img className="clockIcon" src='sand-clock.svg' alt='Timer' />
                  {this.getDuration()}
                </div>
              </div>
              <div className="saveScenarioRightInner product">
                <div className="saveScenarioProduct">
                  <img className="productIcon" src={iconSrc} alt='Timer' />
                  <i>Product: {product}</i>
                </div>
                <div className="saveScenarioAddOn">
                  <text><i>Add-ons</i></text>
                  <div className="saveScenarioAddOns">{this.getAddOns()}</div>
                </div>
              </div>
            </div>
          </div>
        );
      default:
        return -1;
    }
  }

  getAddOns() {
    const productInfo = JSON.parse(JSON.parse(JSON.stringify(sessionStorage.getItem('productData'))));
    let temp = "";

    return (
      <ul style={{ paddingTop: "0%", marginTop: "0%" }}>
        {
          productInfo.product_data.addons.length !== 0 ? (
            productInfo.product_data.addons.map(i => {
              temp = i.split('_').join(' ');
              temp = temp.toLowerCase().split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ');
              return (<li>{temp}</li>)
            })) : "None selected"
        }
      </ul>
    )
  }

  getStepper = () => {
    const steps = ['Objective', 'Simulation Settings', 'Product'];
    const { classes } = this.props;
    const { activeStep } = this.state;

    return (
      <Stepper activeStep={activeStep}>
        {steps.map((label, index) => {
          const props = {};
          return (
            <Step key={label} {...props}>
              <StepLabel
                className={classes.label}
                StepIconProps={{ classes: { active: classes.stepActive, completed: classes.stepCompleted } }}
              >
                {label}
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    )
  }

  getButtons = () => {

    const { classes } = this.props;
    const { activeStep } = this.state;

    return (
      <div style={{ textAlign: "right", paddingRight: "6%" }}>
        <Button
          onClick={this.handleBack}
          className={classes.button}
          style={{ backgroundColor: "lightgrey", boxShadow: "none" }}
        >
          Back
        </Button>
        {activeStep !== 3 ?
          (
            <Button
              variant="contained"
              onClick={this.handleNext}
              className={classes.button}
              style={{ marginLeft: "5%", backgroundColor: "#00a7bd", color: "white", boxShadow: "none" }}
            >
              Next
            </Button>
          ) : (
            <Button
              variant="contained"
              onClick={this.toSimulation}
              className={classes.button}
              style={{ marginLeft: "5%", backgroundColor: "#00a7bd", color: "white", boxShadow: "none" }}
            >
              Submit
            </Button>
          )}
      </div>

    )
  }

  handleNext = () => {
    const { activeStep } = this.state;
    if (activeStep === 2) {
      GlobalEvents.trigger("storeProductDetails");
    }

    this.setState({
      activeStep: activeStep + 1
    });
  };

  handleBack = () => {
    const { activeStep } = this.state;

    if (activeStep === 3) {
      this.updateText()
    }

    if (activeStep === 2) {
      GlobalEvents.trigger("storeProductDetails");
    }

    if (this.getStepContent(activeStep - 1) < 0) {
      GlobalEvents.trigger('handleScenario', 0)
    }

    this.setState({
      activeStep: activeStep - 1
    });
  };

  toSimulation = () => {
    const scenarioName = document.getElementById("ScenarioName").innerHTML;
    const scenarioDescription = document.getElementById("ScenarioDescription").innerHTML

    if (scenarioName.length > 0 && scenarioDescription.length > 0) {

      this.setState({
        scenarioName: scenarioName,
        scenarioDescription: scenarioDescription
      })

      const productInfo = JSON.parse(sessionStorage.getItem('productData'));
      const pricingData = JSON.parse(sessionStorage.getItem('pricingData'));

      const simSettingsStateData = JSON.parse(sessionStorage.getItem("simSettings"));
      const dataToSend = simSettingsStateData.dataToSend;
      simSettingsStateData.accordians.forEach(acc => {
        acc.content.forEach(sliderOb => {
          if (sliderOb.destination) {
            const keys = sliderOb.destination.split(".");
            if (keys.length === 2) {
              dataToSend[keys[0]][keys[1]] = [sliderOb.selectedValue];
            } else if (keys.lenth === 3) {
              dataToSend[keys[0]][keys[1]][keys[2]] = [sliderOb.selectedValue];
            }
          }
        });
      });
      dataToSend["levelZeroParameters"]["model_type"] = [(simSettingsStateData.modelType.toLowerCase() === "individual" ? "Individual" : "Combined")];
      dataToSend.productParameters.beveragecategory = productInfo.product_data.category;

      let startDateMilli = new Date(dataToSend["simParameters"]["startTimeStamp"]).getTime();
      let offset = new Date().getTimezoneOffset() * 60000;
      let startDate = (startDateMilli - offset) / 1000;

      dataToSend["simParameters"]["startTimeStamp"] = [startDate]



      let temp = {}
      temp.brand = 0;
      temp.health = productInfo.product_data.health;
      temp.taste = productInfo.product_data.taste;
      temp.pleasure = productInfo.product_data.pleasure;
      temp.visualAppeal = productInfo.product_data.visual;
      temp.price = parseFloat(pricingData.cost_to_customer.replace("$", ""));
      temp.marketShare = 0;

      dataToSend.productParameters.Product_attributes[0] = temp;

      let createScenarioData = {};

      createScenarioData.userId = config.userId;
      createScenarioData.yourBrandAddOns = JSON.parse(sessionStorage.getItem("productData")).product_data.addons
      createScenarioData.noOfCompetitor = parseInt(sessionStorage.getItem("noOfCompetitors"));
      createScenarioData.scenarioName = scenarioName
      createScenarioData.scenarioDescription = scenarioDescription
      createScenarioData.simParameters = dataToSend.simParameters;
      createScenarioData.levelZeroParameters = dataToSend.levelZeroParameters;
      createScenarioData.productParameters = dataToSend.productParameters;
      createScenarioData.simStatus = dataToSend.simStatus;
      createScenarioData.pricing = pricingData;
      createScenarioData.topicName = null;
      createScenarioData.productInfo = productInfo;
      createScenarioData.promotions = [
        {
          "channel": "tv",
          "slots": [
            "None"
          ],
          "days": [
            "None"
          ],
          "intensity": 0,
          "impressions": 0
        },
        {
          "channel": "radio",
          "slots": [
            "None"
          ],
          "days": [
            "None"
          ],
          "intensity": 0,
          "impressions": 0
        },
        {
          "channel": "printmedia",
          "slots": [
            "None"
          ],
          "days": [
            "None"
          ],
          "intensity": 0,
          "impressions": 0
        },
        {
          "channel": "billboard",
          "slots": [
            "None"
          ],
          "days": [
            "None"
          ],
          "intensity": 0,
          "impressions": 0
        },
        {
          "channel": "digitalmedia",
          "slots": [
            "None"
          ],
          "days": [
            "None"
          ],
          "intensity": 0,
          "impressions": 0
        }
      ]

      Object.keys(createScenarioData.levelZeroParameters).forEach(temp1 => {
        if (temp1 === "model_type") {
          createScenarioData.levelZeroParameters[temp1] = createScenarioData.levelZeroParameters[temp1][0];
        } else {
          Object.keys(createScenarioData.levelZeroParameters[temp1]).forEach(temp2 => {
            createScenarioData.levelZeroParameters[temp1][temp2] = createScenarioData.levelZeroParameters[temp1][temp2][0];
          })
        }
      })

      Object.keys(createScenarioData.simParameters).forEach(temp3 => {
        createScenarioData.simParameters[temp3] = createScenarioData.simParameters[temp3][0];
      })

      fetch(config.api.url + "createScenario", {
        method: 'POST',
        headers: {
          "Authorization": `${config.token}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(createScenarioData)
      }, { mode: 'cors' })
        .then(response => {
          return response.json();
        }).then(response => {
          config.scenarioId = response["scenarioId"];
          config.scenarioName = this.state.scenarioName;
          GlobalEvents.trigger("triggercountry", 'usa-simulation');

        }).catch(err => {

        });
    } else {
      this.setState({
        openSnackBar: true
      })
    }
  }

  getDuration() {
    const simSettings = JSON.parse(JSON.parse(JSON.stringify(sessionStorage.getItem('simSettings'))));
    const startDate = new Date(simSettings.accordians[0].content[2].selectedValue).setFullYear(2020);
    const endDate = new Date(simSettings.accordians[0].content[3].selectedValue).setFullYear(2020);

    return (<i>{moment(startDate).format('Do MMM YYYY')} - {moment(endDate).format('Do MMM YYYY')}</i>)
  }

  render() {

    const self = this.state;

    return (
      <Dialog className="dialogWizard"
        open={self.showDialog}
        keepMounted
        disableBackdropClick
        disableEscapeKeyDown
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        autoDetectWindowHeight={false}
        autoScrollBodyContent={false}
        contentStyle={{
          height: "40vh",
          width: "100%"
        }}
        maxWidth='false'
      >
        <IconButton onClick={this.showDialog.bind(this)} color="primary" style={{ padding: "5px", position: "absolute", right: "1%", top: "1%", color: "grey" }}>
          <CloseIcon />
        </IconButton>
        <DialogTitle id="alert-dialog-slide-title" style={{ textAlign: "center", padding: "0px", margin: "0%", marginBottom: "1%" }} >
          <h2>Configure Scenario</h2>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div className="createScenarioWizard">
              <div className={this.props.classes.root} style={{ textAlign: "center", padding: "0px", margin: "0%" }}>
                {this.getStepper()}
                {this.getStepContent(self.activeStep)}
                {this.getButtons()}
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    );
  }
}

ScenarioWizard.propTypes = {
  classes: PropTypes.object
};

export default withStyles(styles)(ScenarioWizard);
